import "./index.scss";
import { Drawer, Select } from "antd";
import { CloseOutlined } from "@ant-design/icons";
import Scrollbars from "react-custom-scrollbars";
import HeaderTitle from "../../../../../components/HeaderTitle";
import MySpin from "../../../../../components/MySpin";
import { useEffect, useMemo, useState } from "react";

const HistoryDrawer = (props) => {
  const { visible, onCancel, loading, historyList } = props;

  const formatDate = (t) => {
    if (!t) return "";
    // 兼容 ISO 字符串：2026-01-12T17:20:47 或 2026-01-12 17:20:47
    return String(t).slice(0, 10);
  };

  const dateOptions = useMemo(() => {
    const dates = (historyList || [])
      .map((item) => formatDate(item?.change_time))
      .filter(Boolean);
    const unique = Array.from(new Set(dates)).sort((a, b) =>
      b.localeCompare(a)
    );
    return unique.map((d) => ({ label: d, value: d }));
  }, [historyList]);

  const [selectedDate, setSelectedDate] = useState("");

  useEffect(() => {
    if (!visible) return;
    const latest = dateOptions?.[0]?.value || "";
    setSelectedDate(latest);
  }, [visible, dateOptions]);

  const selectedContent = useMemo(() => {
    if (!selectedDate) return "";
    const list = (historyList || [])
      .filter((item) => formatDate(item?.change_time) === selectedDate)
      .sort((a, b) =>
        String(b?.change_time || "").localeCompare(String(a?.change_time || ""))
      )
      .map((item) => item?.change_content)
      .filter(Boolean);

    return list.join(
      "\n\n----------------------------------------------------------------------------------\n\n"
    );
  }, [historyList, selectedDate]);

  const renderWithLineBreaks = (text) => {
    if (!text) return "暂无";
    let normalized = String(text);
    // 统一处理常见转义：\r\n、\r、\t 等
    normalized = normalized.replace(/\\r\\n/g, "\\n"); // 先把 \r\n 归一到 \n
    normalized = normalized.replace(/\\r/g, ""); // 单独的 \r 直接去掉
    normalized = normalized.replace(/\\t/g, "    "); // \t 替换成若干空格

    // 只按字符串中的 '\n'（即文本里的 \\n）分割
    const lines = normalized.split(/\\n/g);
    return lines.map((line, index) => (
      <span key={index}>
        {line}
        {index < lines.length - 1 && <br />}
      </span>
    ));
  };

  const handleCancel = () => {
    onCancel && onCancel();
  };

  return (
    <Drawer
      title="查看历史版本"
      placement="right"
      width="600px"
      className="ServiceDevHistoryDrawer"
      onClose={handleCancel}
      visible={visible}
      push={false}
      closable={false}
      destroyOnClose={true}
      extra={
        <CloseOutlined
          style={{ fontSize: "16px" }}
          onClick={() => {
            handleCancel();
          }}
        />
      }
    >
      {loading ? (
        <MySpin />
      ) : (
        <Scrollbars
          autoHide={true}
          autoHideTimeout={5000}
          style={{ height: `100%`, width: "100%" }}
        >
          <div className="historyContent">
            <div className="historyHeader">
              <HeaderTitle title="历史信息" />
              <Select
                style={{ width: 160 }}
                placeholder="请选择日期"
                value={selectedDate || undefined}
                options={dateOptions}
                onChange={(v) => setSelectedDate(v)}
                allowClear={false}
              />
            </div>
            <div className="textBox">
              <div className="textRow">
                <div className="textValue">
                  {renderWithLineBreaks(selectedContent)}
                </div>
              </div>
            </div>
          </div>
        </Scrollbars>
      )}
    </Drawer>
  );
};

export default HistoryDrawer;
